module.exports = __webpack_public_path__ + "/build/web/images/fabrics/agde-17.b1e0190ce6c166b4e54b079726b49186.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/fabrics/agde-17.jpg
// module id = 130
// module chunks = 13